import React from 'react';
import PropTypes from 'prop-types';
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';
import {
  List, ListItem, ListItemIcon, ListItemText, Collapse, withStyles,
} from '@material-ui/core';
import { icons, styles } from './Icons';
// eslint-disable-next-line import/no-cycle
import NavItem from '../NavItem';

function getNavItems(items, depth, onNavItem) {
  return items.map((navItem) => (
    <NavItem key={navItem.url} navItem={navItem} depth={depth} onNavItem={onNavItem} />
  ));
}

export class NavExpandImpl extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
    };
    this.handleClick = this.handleClick.bind(this);
  }

  handleClick() {
    this.setState((state) => ({ open: !state.open }));
  }

  render() {
    const {
      navItem, depth, classes, onNavItem,
    } = this.props;
    const { open } = this.state;
    return (
      <>
        <ListItem
          button
          onClick={this.handleClick}
          className={classes.listItem}
          style={{ paddingLeft: `${depth * 10}px` }}
        >
          <ListItemIcon className={classes.icon}>{icons[navItem.icon]}</ListItemIcon>
          <ListItemText
            primary={navItem.primaryText}
            disableTypography
            classes={{
              root: classes.text,
            }}
          />
          {open ? (
            <ExpandLess
              classes={{
                root: classes.text,
              }}
            />
          ) : (
            <ExpandMore
              classes={{
                root: classes.text,
              }}
            />
          )}
        </ListItem>
        <Collapse in={open} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
            {getNavItems(navItem.children.data, depth + 1, onNavItem)}
          </List>
        </Collapse>
      </>
    );
  }
}

const navLinkProps = {
  navItem: PropTypes.shape({
    icon: PropTypes.string,
    primaryText: PropTypes.string,
    children: PropTypes.shape({
      data: PropTypes.arrayOf(PropTypes.shape({})),
    }),
  }).isRequired,
  depth: PropTypes.number.isRequired,
  classes: PropTypes.shape({
    listItem: PropTypes.string,
    icon: PropTypes.string,
    text: PropTypes.string,
  }).isRequired,
  onNavItem: PropTypes.func.isRequired,
};

export { navLinkProps };

NavExpandImpl.propTypes = navLinkProps;

export default withStyles(styles)(NavExpandImpl);
